
import { SupportForm } from "../../components/elements/SupportForm";

export const Support = () => {
  return (
    <>
      <SupportForm />
    </>
  );
};

export default Support;